<template>
  <div class="twitter-post-filter" layout="column">
    <div class="mb-x3">
      <div class="mb-x1">応募期間</div>
      <AppDateRangePicker
        :value="entryDateRange"
        :campaign="campaign"
        @change="onChangeEntryDateRange"
        :placeholder="['開始日時', '終了日時']"
        size="small"
      />
    </div>
    <div class="mb-x3" layout="row">
      <div>
        <div class="mb-x1">応募グループ</div>
        <el-select
          v-model="prizeId"
          size="small"
          placeholder="応募グループ"
          clearable
          @change="onChangeFilter('prizeId')"
        >
          <el-option v-for="(item, index) in prizeOptions" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="ml-x1">
        <div class="mb-x1">ポスト種別</div>
        <el-select
          v-model="postType"
          size="small"
          placeholder="ポスト種別"
          clearable
          @change="onChangeFilter('postType')"
        >
          <el-option
            v-for="(item, index) in typeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="ml-x1">
        <div class="mb-x1">フォロー</div>
        <el-select
          v-model="isFollowing"
          size="small"
          placeholder="フォロー"
          clearable
          @change="onChangeFilter('isFollowing')"
        >
          <el-option
            v-for="(item, index) in isFollowerOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="ml-x1">
        <div class="mb-x1">候補者</div>
        <el-select
          v-model="isCandidate"
          size="small"
          placeholder="候補者"
          clearable
          @change="onChangeFilter('isCandidate')"
        >
          <el-option
            v-for="(item, index) in isCandidateOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="ml-x1">
        <div class="mb-x1">当選者</div>
        <el-select v-model="isWinner" size="small" placeholder="当選者" clearable @change="onChangeFilter('isWinner')">
          <el-option
            v-for="(item, index) in isWinnerOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="ml-x1" v-if="campaignType === 'old_web_instantwin'">
        <div class="mb-x1">Web当選者</div>
        <el-select
          v-model="isWebInstantwinWinner"
          size="small"
          placeholder="Web当選者"
          clearable
          @change="onChangeFilter('isWebInstantwinWinner')"
        >
          <el-option
            v-for="(item, index) in isWebInstantwinOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="mb-x3" layout="row">
      <div>
        <div class="mb-x1">メディア</div>
        <el-select v-model="isMedia" size="small" placeholder="メディア" clearable @change="onChangeFilter('isMedia')">
          <el-option
            v-for="(item, index) in isMediaOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="ml-x1" v-if="campaignType !== 'old_web_instantwin'">
        <div class="mb-x1">ウィジェット表示</div>
        <el-select
          v-model="isWidget"
          size="small"
          placeholder="ウィジェット表示"
          clearable
          @change="onChangeFilter('isWidget')"
        >
          <el-option
            v-for="(item, index) in isWidgetOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="ml-x1">
        <div class="mb-x1">凍結フラグ</div>
        <el-select
          v-model="isSuspendedAccount"
          size="small"
          placeholder="凍結フラグ"
          clearable
          @change="onChangeFilter('isSuspendedAccount')"
        >
          <el-option
            v-for="(item, index) in isSuspendedAccountOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="ml-x1">
        <div class="mb-x1">アカウント名</div>
        <el-input
          class="account-name"
          v-model="accountName"
          size="small"
          placeholder="検索(完全一致)"
          @change="onChangeFilter('accountName')"
          clearable
        >
          <template slot="prepend"><i class="mdi mdi-magnify"></i></template>
        </el-input>
      </div>
    </div>
    <div class="mb-x0" layout="row">
      <div>
        <el-button type="primary" @click="changeFilter" :disabled="loading"
          ><i class="mdi mdi-magnify"></i>検索</el-button
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import { AppDateRangePicker } from '@/client/components/_atoms'
import { TrackingService } from '@/client/services'
import { useTwitterPostsStore } from '@/client/store/useTwitterPostsStore'
import { TGetTwitterPostsParams } from '@/typings/api/twitter_posts.type'

export default defineComponent({
  components: {
    AppDateRangePicker
  },
  created() {
    this.prizeId = this.params.prizeId
    this.postType = this.params.postType
    this.isFollowing = this.params.isFollowing
    this.isCandidate = this.params.isCandidate
    this.isWinner = this.params.isWinner
    this.isWebInstantwinWinner = this.params.isWebInstantwinWinner
    this.isMedia = this.params.isMedia
    this.isWidget = this.params.isWidget
    this.isSuspendedAccount = this.params.isSuspendedAccount
    this.accountName = this.params.accountName

    // 既存のパラメータがある場合はそれを使用
    if (this.params.entryDateFrom || this.params.entryDateTo) {
      this.entryDateRange = [this.params.entryDateFrom || '', this.params.entryDateTo || '']
    } else {
      // デフォルト値は空にしておく（AppDateRangePickerで設定）
      this.entryDateRange = ['', '']
    }
  },
  data() {
    return {
      prizeId: '' as TGetTwitterPostsParams['prizeId'],
      postType: '',
      isFollowing: '' as TGetTwitterPostsParams['isFollowing'],
      isCandidate: '' as TGetTwitterPostsParams['isCandidate'],
      isWinner: '' as TGetTwitterPostsParams['isWinner'],
      isWebInstantwinWinner: '' as TGetTwitterPostsParams['isWebInstantwinWinner'],
      isMedia: '' as TGetTwitterPostsParams['isMedia'],
      isWidget: '' as TGetTwitterPostsParams['isWidget'],
      isSuspendedAccount: '' as TGetTwitterPostsParams['isSuspendedAccount'],
      accountName: '',
      entryDateRange: ['', ''],
      typeOptions: [
        { value: '', label: '指定なし' },
        { value: 'tweet', label: 'ポスト' },
        { value: 'retweet', label: '公式リポスト' },
        { value: 'quote_tweet', label: '引用' },
        { value: 'mention', label: 'メンション' },
        { value: 'reply', label: '返信' }
      ],
      isFollowerOptions: [
        { value: '', label: '指定なし' },
        { value: 1, label: 'フォローあり' },
        { value: 0, label: 'フォローなし' }
      ],
      isMediaOptions: [
        { value: '', label: '指定なし' },
        { value: 1, label: 'メディアあり' },
        { value: 0, label: 'メディアなし' }
      ],
      isCandidateOptions: [
        { value: '', label: '指定なし' },
        { value: 1, label: '候補者フラグあり' },
        { value: 0, label: '候補者フラグなし' }
      ],
      isWidgetOptions: [
        { value: '', label: '指定なし' },
        { value: 1, label: 'ウイジェット表示あり' },
        { value: 0, label: 'ウイジェット表示なし' }
      ],
      isWinnerOptions: [
        { value: '', label: '指定なし' },
        { value: 1, label: '当選フラグあり' },
        { value: 0, label: '当選フラグなし' }
      ],
      isWebInstantwinOptions: [
        { value: '', label: '指定なし' },
        { value: 1, label: 'WEB抽選で当選' },
        { value: 0, label: 'WEB抽選で落選' }
      ],
      isSuspendedAccountOptions: [
        { value: '', label: '指定なし' },
        { value: 1, label: '凍結フラグあり' },
        { value: 0, label: '凍結フラグなし' }
      ]
    }
  },
  computed: {
    ...mapState(useTwitterPostsStore, {
      prizes: state => state.prizes,
      params: state => state.params,
      campaign: state => state.campaign,
      campaignType: state => state.campaign?.type,
      loading: state => state.loading
    }),

    prizeOptions() {
      return [{ id: '', name: '指定なし' }, ...this.prizes]
    }
  },
  methods: {
    ...mapActions(useTwitterPostsStore, ['setParams']),

    onChangeFilter(value: string) {
      switch (value) {
        case 'prizeId':
          TrackingService.sendEvent('select:応募履歴（X）|応募グループ')
          break
        case 'postType':
          TrackingService.sendEvent('select:応募履歴（X）|ポスト種別')
          break
        case 'isFollowing':
          TrackingService.sendEvent('select:応募履歴（X）|フォロー')
          break
        case 'isCandidate':
          TrackingService.sendEvent('select:応募履歴（X）|候補者')
          break
        case 'isWinner':
          TrackingService.sendEvent('select:応募履歴（X）|当選者')
          break
        case 'isWebInstantwinWinner':
          TrackingService.sendEvent('select:応募履歴（X）|Web当選者')
          break
        case 'isMedia':
          TrackingService.sendEvent('select:応募履歴（X）|メディア')
          break
        case 'isWidget':
          TrackingService.sendEvent('select:応募履歴（X）|ウィジェット表示')
          break
        case 'isSuspendedAccount':
          TrackingService.sendEvent('select:応募履歴（X）|凍結フラグ')
          break
        case 'accountName':
          TrackingService.sendEvent('select:応募履歴（X）|アカウント名')
          break
        case 'entryDateRange':
          TrackingService.sendEvent('select:応募履歴（X）|応募期間')
          break
        default:
          break
      }
    },

    onChangeEntryDateRange(value) {
      TrackingService.sendEvent('select:応募履歴（X）|応募期間')
      this.entryDateRange = value || ['', '']
    },

    async changeFilter() {
      TrackingService.sendEvent('click:応募履歴（X）|検索')

      const params: any = {
        prizeId: this.prizeId,
        postType: this.postType,
        isFollowing: this.isFollowing,
        isCandidate: this.isCandidate,
        isWebInstantwinWinner: this.isWebInstantwinWinner,
        isWinner: this.isWinner,
        isMedia: this.isMedia,
        isWidget: this.isWidget,
        isSuspendedAccount: this.isSuspendedAccount,
        accountName: this.accountName
      }

      // 応募期間を追加
      if (this.entryDateRange[0]) {
        params.entryDateFrom = this.entryDateRange[0]
      }
      if (this.entryDateRange[1]) {
        params.entryDateTo = this.entryDateRange[1]
      }

      await this.setParams(params)
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.account-name {
  width: $spacing-unit * 36;
}

.el-date-editor {
  width: $spacing-unit * 45;

  .el-range-separator {
    width: auto;
    padding: 0 5px;
    line-height: 32px;
  }
}
</style>
